import LazyLoad from "vanilla-lazyload";
import { textScramble, appearY, growB } from "./gsap/gsapEffects";

var lazyObj;

function createLazyLoad() {
    lazyObj = new LazyLoad({
        elements_selector: "[data-dpk-call]",
        thresholds: "0% 0% -20% 0%",
        unobserve_entered: true, // fn execute only once
        callback_enter: executeLazyFunction,
    });
}

function destroyLazyLoad() {
    lazyObj.destroy();
}

function executeLazyFunction(element) {
    const funName = element.getAttribute("data-dpk-call");
    const lazyFunction = window.lazyFunctions[funName];
    if (!lazyFunction) return;
    lazyFunction(element);
}



/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     Lazy Functions will invoded on  Viewport
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/

window.lazyFunctions = {
    textScr(el) {
        textScramble(el);
    },
    appearY(el) {
        appearY(el);
    },
    growB(el) {
        growB(el);
    },
};

export { createLazyLoad, destroyLazyLoad };
